"use strict";
'use client';

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Navigation = void 0;
var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));
var _react = _interopRequireDefault(require("react"));
var _dataEncoreIds = require("../../dataEncoreIds.js");
var _index = require("../../styles/index.js");
var _index2 = require("../LogoSpotify/index.js");
var _Body = require("./Body.js");
var _Footer = require("./Footer.js");
var _Header = require("./Header.js");
var _Nav = require("./Nav.js");
var _excluded = ["children", "colorSet", "header", "footer", "className"];
/**
 * A vertical side navigation used for text links. It helps users maintain a sense of context throughout an application,
 * as well as providing a consistent pattern to navigate between sections.
 *
 * [Storybook](https://encore-web.spotify.net/?path=/docs/components-navigation--docs) |
 * [Encore site](https://encore.spotify.net/web/components/navigation) |
 * [Github](https://ghe.spotify.net/encore/web/tree/master/src/core/components/Navigation) |
 * [Figma](https://www.figma.com/design/bnQXqGkLeiTlbk8JXGDcsX/%E2%9A%99%EF%B8%8F-%E2%80%8A%E2%80%8BEncore-Web-Components?m=auto&node-id=885-417&t=rDdNHhld76Wp0C3r-1)
 */
var Navigation = exports.Navigation = function Navigation(_ref) {
  var children = _ref.children,
    _ref$colorSet = _ref.colorSet,
    colorSet = _ref$colorSet === void 0 ? 'mutedAccent' : _ref$colorSet,
    header = _ref.header,
    footer = _ref.footer,
    className = _ref.className,
    props = (0, _objectWithoutProperties2["default"])(_ref, _excluded);
  return /*#__PURE__*/_react["default"].createElement(_Nav.Nav, Object.assign({
    className: (0, _index.addColorSet)(colorSet, className)
  }, props, {
    "data-encore-id": _dataEncoreIds.ENCORE_DATA_IDS.Navigation
  }), header && /*#__PURE__*/_react["default"].createElement(_Header.Header, null, header), /*#__PURE__*/_react["default"].createElement(_Body.Body, null, children), /*#__PURE__*/_react["default"].createElement(_Footer.Footer, null, footer ? /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null, footer) : /*#__PURE__*/_react["default"].createElement(_index2.LogoSpotify, {
    height: "24",
    semanticColor: "textSubdued",
    "aria-label": "Spotify"
  })));
};